// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import WebNavbar from "../Components/WebNavbar";
// import ScrollToTop from "./ScrollToTop";
// import HomePage from "../Container/HomePage";
// import LoginPage from "../Container/LoginPage";
// import SignUpPage from "../Container/SignUpPage";
// import AboutPage from "../Container/AboutPage";
// import ContactPage from "../Container/ContactPage";
// import MenuDetailsPage from "../Container/MenuPage/MenuDetailsPage";
// import CartPage from "../Container/MenuPage/CartPage";
// import CustomerProfile from "../Components/Customer/CustomerProfile";
// import CheckoutPage from "../Container/MenuPage/CheckoutPage";
// import OrdersPage from "../Container/MenuPage/OrdersPage";
// import OrderDetailsPage from "../Container/MenuPage/OrderDetailsPage";

// const defaultRouteElements = {
//   "/": <HomePage />,
//   "/login": <LoginPage />,
//   "/signup": <SignUpPage />,
//   "/about": <AboutPage />,
//   "/contact": <ContactPage />,
//   "/menu": <MenuDetailsPage />,
//   "/cart": <CartPage />,
//   "/customer/profile": <CustomerProfile />,
//   "/menu/:id": <MenuDetailsPage />,
//   "/checkout": <CheckoutPage />,
//   "/orders": <OrdersPage/>,
//   "/orders/:orderId": <OrderDetailsPage/>
// };

// const WebRoutes = ({
//   restaurantName = "Restaurant",
//   brandConfig = {},
//   visibleRoutes,
//   hiddenRoutes = [],
//   extraRoutes = [],
//   extraRouteElements = [],
//   logo,
//   iframeMode = false,
// }) => {
//   const routeEntries = Object.entries(defaultRouteElements);

//   let filteredRouteEntries = routeEntries;

//   if (Array.isArray(visibleRoutes) && visibleRoutes.length > 0) {
//     filteredRouteEntries = filteredRouteEntries.filter(([path]) =>
//       visibleRoutes.includes(path)
//     );
//   }

//   if (Array.isArray(hiddenRoutes) && hiddenRoutes.length > 0) {
//     filteredRouteEntries = filteredRouteEntries.filter(
//       ([path]) => !hiddenRoutes.includes(path)
//     );
//   }

//   return (
//     <>
//       <ScrollToTop />
//       <WebNavbar
//         restaurantName={restaurantName}
//         brandConfig={brandConfig}
//         visibleRoutes={visibleRoutes}
//         hiddenRoutes={hiddenRoutes}
//         extraRoutes={extraRoutes}
//         logo={logo}
//         iframeMode={iframeMode}
//       />

//       <Routes>
//         {filteredRouteEntries.map(([path, element]) => (
//           <Route key={path} path={path} element={element} />
//         ))}

//         {Array.isArray(extraRouteElements) &&
//           extraRouteElements.map((route) => (
//             <Route
//               key={route.path}
//               path={route.path}
//               element={route.element}
//             />
//           ))}
//       </Routes>
//     </>
//   );
// };

// export default WebRoutes;



import React from "react";
import { Routes, Route } from "react-router-dom";
import WebNavbar from "../Components/WebNavbar";
import ScrollToTop from "./ScrollToTop";
import HomePage from "../Container/HomePage";
import LoginPage from "../Container/LoginPage";
import SignUpPage from "../Container/SignUpPage";
import AboutPage from "../Container/AboutPage";
import ContactPage from "../Container/ContactPage";
import MenuDetailsPage from "../Container/MenuPage/MenuDetailsPage";
import CartPage from "../Container/MenuPage/CartPage";
import CustomerProfile from "../Components/Customer/CustomerProfile";
import CheckoutPage from "../Container/MenuPage/CheckoutPage";
import OrdersPage from "../Container/MenuPage/OrdersPage";
import OrderDetailsPage from "../Container/MenuPage/OrderDetailsPage";
import CustomerChatbot from "../Components/Customer/CustomerChatbot";

const defaultRouteElements = {
  "/": <HomePage />,
  "/login": <LoginPage />,
  "/signup": <SignUpPage />,
  "/about": <AboutPage />,
  "/contact": <ContactPage />,
  "/menu": <MenuDetailsPage />,
  "/cart": <CartPage />,
  "/customer/profile": <CustomerProfile />,
  "/menu/:id": <MenuDetailsPage />,
  "/checkout": <CheckoutPage />,
  "/orders": <OrdersPage />,
  "/orders/:orderId": <OrderDetailsPage />,
};

const WebRoutes = ({
  restaurantName = "Restaurant",
  brandConfig = {},
  visibleRoutes,
  hiddenRoutes = [],
  extraRoutes = [],
  extraRouteElements = [],
  logo,
  iframeMode = false,
  clientId,
}) => {
  const routeEntries = Object.entries(defaultRouteElements);

  let filteredRouteEntries = routeEntries;

  if (Array.isArray(visibleRoutes) && visibleRoutes.length > 0) {
    filteredRouteEntries = filteredRouteEntries.filter(([path]) =>
      visibleRoutes.includes(path)
    );
  }

  if (Array.isArray(hiddenRoutes) && hiddenRoutes.length > 0) {
    filteredRouteEntries = filteredRouteEntries.filter(
      ([path]) => !hiddenRoutes.includes(path)
    );
  }

  return (
    <>
      <ScrollToTop />

      <WebNavbar
        restaurantName={restaurantName}
        brandConfig={brandConfig}
        visibleRoutes={visibleRoutes}
        hiddenRoutes={hiddenRoutes}
        extraRoutes={extraRoutes}
        logo={logo}
        iframeMode={iframeMode}
      />

      <Routes>
        {filteredRouteEntries.map(([path, element]) => (
          <Route key={path} path={path} element={element} />
        ))}

        {Array.isArray(extraRouteElements) &&
          extraRouteElements.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={route.element}
            />
          ))}
      </Routes>

      {!iframeMode && (
        <CustomerChatbot
          clientId={clientId}
          restaurantName={restaurantName}
          brandConfig={brandConfig}
        />
      )}
    </>
  );
};

export default WebRoutes;